module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-47.0b459294.png";